module.exports = __webpack_public_path__ + "img/American-Credit-Equipment-Financing-Customer-Vioce-640w.318370d.png";